import {useMemo} from 'react';
import usePriceQuote from './queries/quotes';

const calculateDiscountPercentage = (getMinimumQuote, getQuote) => {
  if (getMinimumQuote && getQuote) {
    return Math.round(((getMinimumQuote - getQuote) / getMinimumQuote) * 100);
  }
  return null;
};

export default function useDiscountPercentage(
  getQuote,
  currentColor,
  canOrderSingles
) {
  const {data: minimumQuote} = usePriceQuote(
    currentColor?.legacyColorId,
    canOrderSingles,
    1,
    0,
    true
  );
  const getMinimumQuote = minimumQuote && Object.values(minimumQuote);

  return useMemo(
    () => calculateDiscountPercentage(getMinimumQuote, getQuote),
    [getMinimumQuote, getQuote]
  );
}
